export default "__VITE_ASSET__THhh9Zjr__"